@if (!surveyReady) {
<div class="dynamic-form-loading" aria-live="polite" aria-busy="true">
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  <p class="dynamic-form-loading-message">Indlæser formular...</p>
</div>
}
<div
  [style.opacity]="surveyReady ? '1' : '0'"
  [style.transition]="'opacity 0.15s ease'"
  [style.pointer-events]="surveyReady ? 'auto' : 'none'"
>
  @if (noVisiblePages) {
  <p class="no-visible-pages-message">
    @if (noVisiblePagesHint) {
    {{ noVisiblePagesHint }}
    } @else { Der er ingen tilmeldingsmuligheder for dig på nuværende tidspunkt.
    }
  </p>
  } @if (surveyReady && !noVisiblePages && surveyModel) {
  <survey [model]="surveyModel"></survey>
  }
</div>
